<div class="user-menu d-flex justify-content-center item-align-center">
  <ngx-avatars [name]="userDisplayName() ?? ''" size="32" />
  @if (!!userDisplayName()) {
    <div ngbDropdown class="d-inline-block">
      <button type="button" class="btn btn-outline-transparent text-white" id="dropdownBasic1" ngbDropdownToggle>
        {{ userDisplayName() }}
      </button>
      <div ngbDropdownMenu aria-labelledby="dropdownBasic1">
        <button ngbDropdownItem (click)="onProfile()">{{ 'USER_MENU.PROFILE.INFORMATION' | translate }}</button>
        <button ngbDropdownItem (click)="onLogout()">{{ 'USER_MENU.LOGOUT' | translate }}</button>
      </div>
    </div>
  } @else {
    {{ 'Log in' }}
  }
</div>
